import { Model, User } from ".";

export default class CalendarEvent extends Model {
	get singularNoun() {
		return "calendar event";
	}

	get mutations() {
		return {
			user: User
		};
	}

	resource() {
		return "calendar";
	}
}
